import { INotesComponent } from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { AumicoClipboardData } from '../interfaces/aumico-clipboard-data.interface';

const CURRENT_SCHEMA_VERSION = '1.0.0';
const MAX_CLIPBOARD_SIZE_BYTES = 5_000_000; // ~5MB guard (tune as needed)

export function buildClipboardEnvelope(componentType: ComponentType, component: INotesComponent): AumicoClipboardData {
    return {
        aumicoClipboard: true,
        version: CURRENT_SCHEMA_VERSION,
        timestamp: new Date().toISOString(),
        componentType,
        component,
    };
}

/** Shallow schema guard to ensure it's ours before we parse deeply */
export function looksLikeAumicoClipboard(json: unknown): json is AumicoClipboardData {
    if (typeof json !== 'object' || json === null) return false;
    const o = json as Record<string, unknown>;
    return (
        o['aumicoClipboard'] === true &&
        typeof o['version'] === 'string' &&
        typeof o['timestamp'] === 'string' &&
        typeof o['componentType'] === 'string' &&
        typeof o['component'] === 'object'
    );
}

export function serializeEnvelope(envelope: AumicoClipboardData): string {
    const text = JSON.stringify(envelope);
    if (new Blob([text]).size > MAX_CLIPBOARD_SIZE_BYTES) {
        throw new Error('Clipboard payload too large');
    }
    return text;
}

/** Backward compatibility hook (migrate older versions to CURRENT_SCHEMA_VERSION) */
export function migrateIfNeeded(envelope: AumicoClipboardData): AumicoClipboardData {
    // For now pass-through. Later, add per-version transforms here.
    return envelope;
}
